module.exports = __webpack_public_path__ + "static/img/9.1b64726.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/9.png
// module id = d66f
// module chunks = 5